var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"site-entry-history"},[_c('router-link',{attrs:{"to":{ name: 'data-site-details', params: { id: _vm.site.id } }}},[_vm._v("\n    View most recent activities\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }